"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _vue = _interopRequireDefault(require("vue"));
var _vueOtpInput = _interopRequireDefault(require("@bachdgvn/vue-otp-input"));
_vue.default.component("v-otp-input", _vueOtpInput.default);